import { render, staticRenderFns } from "./buyYx.vue?vue&type=template&id=a839d9bc&"
import script from "./buyYx.vue?vue&type=script&lang=js&"
export * from "./buyYx.vue?vue&type=script&lang=js&"
import style0 from "./buyYx.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports